import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from "formik";
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Stack } from '@mui/system';
import { Image } from 'cloudinary-react'
import { useUpdateHeadphoneMutation, useGetAllBrandsQuery, useGetAllStoragesQuery, useGetAllColorsQuery, useGetAllGroupsQuery, useGetAllMaterialsQuery, useGetAllModelsQuery, useAddGroupMutation } from '../../../../features/fullApi';
import { basicSchema } from "./validation";
import { useTheme } from '@mui/material/styles';
import { Store } from 'react-notifications-component';
import { toast } from 'react-hot-toast';
import { CalculateSharp } from '@mui/icons-material';

const EditHeadphone = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  const params = useParams()
  const [headphone, setHeadphone] = useState({})
  const user = JSON.parse(localStorage.getItem('user'))

  const [reqDone, setReqDone] = useState(false)

  const [brand, setBrand] = useState("");
  const [selectedStorages, setSelectedStorages] = useState([]);
  const [color, setColor] = useState("");
  const [material, setMaterial] = useState("");
  const [group, setGroup] = useState("");
  const [model, setModel] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);

  const [type, setType] = useState("");
  const [wear, setWear] = useState("");

  const handleChangeType = (event) => {
    setType(event.target.value);
  };

  const handleChangeWear = (event) => {
    setWear(event.target.value);
  };

  const {data: brands, ergetCallBrandseror: brandsError, isLoading: isLoadingBrands} = useGetAllBrandsQuery()
  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()
  const {data: groups, error: groupsError, isLoading: isLoadingGroups} = useGetAllGroupsQuery()
  const {data: models, error: modelsError, isLoading: isLoadingModels} = useGetAllModelsQuery()



  useEffect(() => {
    const getHeadphone = async () => {
      const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/headphones/find/${params.id}`)
      .then(res => {
        setHeadphone(res.data)
        setReqDone(true)
      })
      .catch(err => console.log(err))
    }
    getHeadphone()
  }, [])

 useEffect(() => {
  const getBrand = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${headphone.brandId}`)
    .then(res => {
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  }
  getBrand()
}, [reqDone])

useEffect(() => {
  setWear(headphone.wear)
  setType(headphone.type)
}, [reqDone])



useEffect(() => {
  const getColor = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${headphone.colorId}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  }
  getColor()
}, [reqDone])

useEffect(() => {
  const getModel = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/models/find/${headphone?.modelId}`)
    .then(res => {
      setModel(res.data)
    })
    .catch(err => console.log(err))
  }
  getModel()
}, [reqDone])



  useEffect(() => {
    values.brands = brands
  }, [brands])

  useEffect(() => {
    values.colors = colors
  }, [colors])

  useEffect(() => {
    values.models = models
  }, [models])


  const handleBrand = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${event.target.value}`)
    .then(res => {
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleColor = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${event.target.value}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleModel = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/models/find/${event.target.value}`)
    .then(res => {
      setModel(res.data)
    })
    .catch(err => console.log(err))
  };




useEffect(() => {
      const fields = ['desc', 'img', 'brandId', 'groupId','quantity', 'colorId', 'materialId', 'modelId', 'price'];
      fields.forEach(field => setFieldValue(field, headphone[field], false));
}, [headphone]);

const [headphoneImgLink, setHeadphoneImgLink] = useState(headphone.img)
const [showBtn, setShowBtn] = useState(false)
const uploadImage = async () => {
  const formData = new FormData()
  formData.append("file", selectedFile)
  formData.append("upload_preset", "zt8iigue")
  const data = await axios.post("https://api.cloudinary.com/v1_1/deqqgmfxk/image/upload", formData)
  .then(res => {
    setHeadphoneImgLink(res.data.secure_url)
    setShowBtn(true)
  })
};

const [updateHeadphone] = useUpdateHeadphoneMutation()
const [addGroup] = useAddGroupMutation()

//constructing the boolean colors checked array
const [groupsObj, setGroupsObj] = useState({})
        useEffect(() => {
          if(!isLoadingGroups) {
            Object.keys(groups).forEach(ele => {
              let key = groups[ele].groupName
                groupsObj[key] = groups[ele]._id;
            });
          }
}, [groups, isLoadingGroups])

const onSubmit = async(values, actions) => {
  if(groupsObj["Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName]?.length>0) {
    console.log(groupsObj["Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName])
    updateHeadphone(
      {_id: headphone._id, title:"Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName + " " + color.colorName, desc: values.desc, modelId: model._id, groupId: groupsObj["Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName], brandId: brand._id, colorId: color._id, price: values.price, quantity: values.quantity, img: headphoneImgLink}, 
      { headers: {'Token': `Bearer ${user?.accessToken}`}}, 
      {id: headphone._id})
    .then(res => {
      toast.success(`Headphones ${wear} ${type} ${brand.brandName} ${model.modelName} ${color.colorName} updated successfully`)
      navigate("/headphones/1")
    })
    .catch((e) => {
      console.log("ERROR UPDATING headphone", e)
    })
  } else {
    addGroup({groupName: "Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName})
    .then(res => {
      updateHeadphone({title: "Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName + " " + color.colorName, desc: values.desc, groupId: res.data._id, brandId: brand._id, colorId: color._id, modelId: model._id, wear: wear, type: type, price: values.price, quantity: values.quantity, img: headphoneImgLink}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      }).then(res => {
        toast.success(`${"Headphones " + wear + " " + type + " " + brand.brandName + " " + model.modelName + " " + color.colorName} successfully created`)
      }).catch((e) => {
        toast("Headphones already exists")
      })
    }).catch(err => {
      console.log("error when creating new group")
    })
  }
}

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: headphone?.title,
      desc: headphone?.desc,
      img: headphone?.img,
      brand: headphone?.brandId,
      group: headphone?.groupId,
      model: headphone?.modelId,
      color: headphone?.colorId,
      material: headphone?.materialId,
      price: headphone?.price,
      quantity: headphone?.quantity
    },
    onSubmit,
  });

  const navigate = useNavigate()

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    uploadImage()
  };

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const renderMobileEditHeadphone = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""} style={{width:'100%', height:'100%'}}>

    {(headphone) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <h3 className="center">Edit {headphone.title}</h3>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField
          id="desc"
          type="text"
          margin="dense"
          value={values.desc}
          onChange={handleChange}
          onBlur={handleBlur}
          focused
          label={"Desc"}
          sx={{
            "& .MuiInputBase-root": {
                height: 40
          }}}
        />
      </FormControl>
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={headphoneImgLink ? headphoneImgLink : headphone.img} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>     
      </div>
      <Stack direction="row" justifyContent="space-between" sx={{marginBottom: '10px'}}>
          <Button  sx={{width: '150px'}} variant="contained" color="secondary" size="small" component="label">
            Upload
            <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
          </Button>
          <Button variant="contained" size="small" sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
        </Stack>


      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

    <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
      <TextField
          id="price"
          type="number"
          margin="dense"
          value={values.price}
          onChange={handleChange}
          onBlur={handleBlur}
          focused
          label={"Price"}
          sx={{
            "& .MuiInputBase-root": {
                height: 40
          }}}
        />
      </FormControl>
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
          sx={{
            "& .MuiInputBase-root": {
                height: 40
          }}}
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {headphone?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a headphone image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderTabletEditHeadphone = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(headphone) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <Typography variant="h6" className="center">Edit Headphone {headphone.title}</Typography>
      <TextField
        id="title"
        type="text"
        value={values.title}    
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.title ? "" : "Title"}
        margin="dense"
      />
      {errors.title && touched.title && <p className="error">{errors.title}</p>}

      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.desc ? "" : "Desc"}
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <Image cloudName="deqqgmfxk"  publicId={headphoneImgLink ? headphoneImgLink : headphone.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      <Stack style={{marginBottom:'20px'}}>
        <Button variant="contained" color="secondary" component="label" style={{marginBottom: '10px'}}>
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button variant="contained" size="small" style={{width: '250px'}} onClick={() => uploadImage()}>Save Image</Button>
      </Stack>


      <FormControl fullWidth>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.price ? "" : "Price"}
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {headphone?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a headphone image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones/1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderDesktopEditHeadphone = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(headphone && color && brand && model) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
    <Typography style={{marginTop:'64px', marginBottom:'10px'}} variant="h5" className="center">Edit Headphone {headphone.title}</Typography> 

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Desc"}
        multiline
        rows={5}
        focused
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}
      </FormControl>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={headphoneImgLink ? headphoneImgLink : headphone.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      </div>
      <Stack direction="row" justifyContent="space-between" style={{marginBottom:'15px', marginTop:'15px'}}>
        <Button size="medium" sx={{width: '150px'}} variant="contained" color="secondary"  component="label">
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button size="medium" variant="contained"  sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
      </Stack>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id ? brand._id : brand}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model._id ? model._id : model}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id ? color._id : color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <InputLabel>Type</InputLabel>
        <Select
          id="type"
          value={type}
          label="Type"
          onChange={handleChangeType}
        >
          <MenuItem value="Wired">Wired</MenuItem>
          <MenuItem value="Wireless">Wireless</MenuItem>
        </Select>
      </FormControl>


      <FormControl fullWidth style={{marginBottom: '10px'}}>
        <InputLabel>Wear</InputLabel>
        <Select
          id="wear"
          value={wear}
          label="Wear"
          onChange={handleChangeWear}
        >
          <MenuItem value="In-Ear">In-Ear</MenuItem>
          <MenuItem value="On-Ear">On-Ear</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>
      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {headphone?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a headphone image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/headphones/page=1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileEditHeadphone() : 
        (isSm) ? renderMobileEditHeadphone() :
        (isMd) ? renderMobileEditHeadphone() :
        renderDesktopEditHeadphone()
      }
    </div>
  );
}

export default EditHeadphone